var error = function PingppError(message, extra) {
  this.message = message;
  this.extra = extra;
};

module.exports = {
  Error: error,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pingpp-js/src/errors.js
// module id = lS9A
// module chunks = 5